"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TextArea = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _Field = require("../Field");

var _BlurInput = _interopRequireDefault(require("../util/BlurInput"));

var _ControlledBlurInput = _interopRequireDefault(require("../util/ControlledBlurInput"));

// TextArea without the Wrapper for custom components
var TextArea =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(TextArea, _React$Component);

  function TextArea() {
    (0, _classCallCheck2["default"])(this, TextArea);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(TextArea).apply(this, arguments));
  }

  (0, _createClass2["default"])(TextArea, [{
    key: "render",
    value: function render() {
      var BlurInputComponent = this.props.controlled ? _ControlledBlurInput["default"] : _BlurInput["default"]; // The BlurInputComponent isn't expecting the 'controlled' prop, so remove it.

      var filteredProps = (0, _omit["default"])(this.props, ['controlled']);
      return _react["default"].createElement(BlurInputComponent, (0, _extends2["default"])({}, filteredProps, {
        textarea: true
      }));
    }
  }]);
  return TextArea;
}(_react["default"].Component);

exports.TextArea = TextArea;
TextArea.displayName = 'TextAreaField';
TextArea.propTypes = process.env.NODE_ENV !== "production" ? {
  id: _propTypes["default"].string,
  value: _propTypes["default"].any,

  /**
   * Fire onChange event after this many ms.
   */
  debounceMs: _propTypes["default"].number,

  /**
   * input placeholder text
   */
  placeholder: _propTypes["default"].node,

  /**
   * set to true to receive onChange after every key press (normally fires on blur or debounce)
   */
  controlled: _propTypes["default"].bool
} : {};
var TextAreaField = (0, _Field.wrap)(TextArea);
var _default = TextAreaField;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/TextAreaField/index.js
// module id = 424
// module chunks = 0